import Section from '@audioeye-marketing/ui/src/components/Section'
import Container from '@audioeye-marketing/ui/src/components/Container'
import Grid from '@audioeye-marketing/ui/src/components/Grid'
import Stack from '@audioeye-marketing/ui/src/components/Stack'
import Typography from '@audioeye-marketing/ui/src/components/Typography'
import colors from '@audioeye-marketing/ui/src/theme/colors'
import ScannerForm from '@/components/storyblok/items/ScannerForm'
import translateSectionStyles from '@/lib/translate-section-styles'

const ScannerSection = () => {
  const sectionStyles = translateSectionStyles({ background_color: { value: colors.neutral[50] } })

  return (
    <Section {...sectionStyles}>
      <Container constraint="lg">
        <Grid direction="row" container spacing={{ xs: 5, md: 10 }}>
          <Grid xs={12} md={6}>
            <Typography
              level="h2"
              sx={{ textAlign: { xs: 'center', md: 'left' } }}
            >{`Ready to test your site's accessibility?`}</Typography>
          </Grid>
          <Grid xs={12} md={6}>
            <Stack sx={{ height: '100%' }} alignItems={{ xs: 'flex-start', sm: 'center' }} justifyContent="center">
              <ScannerForm blok={{ card: true }} />
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Section>
  )
}

export default ScannerSection
